// extracted by mini-css-extract-plugin
export default {"label":"Label_label__Tf6of","required":"Label_required__vcpW9"};